import * as Yup from "yup";

/**
 * Obrazac posebnog uvjeta, shema po koraku čarobnjaka.
 *
 * Pragovi odobravanja i brana „nikad ispod nabave" NISU ovdje — one stoje u modelu na
 * backendu. Ovdje su samo obavezna polja, da se ne ide na server bez razloga i roka.
 */

export const OVERRIDE_TARGET_STEP_SCHEMA = Yup.object().shape({
  tenantId: Yup.string().nullable().required("Klijent je obavezan"),
  keyCode: Yup.string().nullable().required("Ključ je obavezan"),
});

export const OVERRIDE_AMOUNT_STEP_SCHEMA = Yup.object().shape({
  value: Yup.number().nullable().required("Vrijednost je obavezna"),
});

export const OVERRIDE_TERMS_STEP_SCHEMA = Yup.object().shape({
  reason: Yup.string()
    .nullable()
    .required("Razlog je obavezan, bez njega se ne vidi zašto je uvjet dan"),
  validFrom: Yup.string().nullable().required("Početak važenja je obavezan"),
  validTo: Yup.string()
    .nullable()
    .required("Rok je obavezan, bez njega bi uvjet ostao zauvijek"),
});
